module.exports = __webpack_public_path__ + "img/logo-colors-svg.92818872.svg";